import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { STATIC_CLASSES } from './Cta6.const'

export const useCta6 = props => {
	const { metaData } = props

	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.image })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })
	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	return [
		{
			classes: STATIC_CLASSES,
			withImage: !!metaData.image?.image,
			image: metaData.image,
			mobileAlignment: metaData.mobileAlignment?.metaValue,
			mobileButtonWidth: metaData.mobileButtonWidth?.isWide ? '100%' : 'auto',

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextConfig: metaData.buttonText?.config,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextEditable,
		},
		{ handleImageClick, handleTextClick, handleButtonClick, handleTextChange, handleButtonTextChange },
	]
}
